
import Home from './Home'
import ToolTip from './tooltip'
import Notification from './notification'

const routes = [
  {
    type: 'collapse',
    key: 'home',
    route: '/',
    component: <Home />,
  },
  {
    type: 'collapse',
    key: 'home',
    route: '/:page_id',
    component: <ToolTip />,
  },
  {
    type: 'collapse',
    key: 'home',
    route: 'notification/:page_id',
    component: <Notification />,
  },
]

export default routes
